import type { Doc } from "building-types/doc";
import { docEntityTypes } from "building-types/doc/docEntityTypes";
import type { DocEntityType } from "building-types/doc/docEntityTypes";
import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import { Lazy } from "common/data/lazy";
import { entityTypeSupportsFormulaDisabled } from "doc/schema/docSchemaValidation";
import type { DocEntity } from "./docEntity";
import docForEachEntity from "./docForEachEntity";

/**
 * Lazily computed list of entity types that support the FormulaDisabled field.
 */
const formulaDisabledEntityTypes = new Lazy<DocEntityType[]>(() =>
  docEntityTypes.filter((type) => entityTypeSupportsFormulaDisabled(type)),
);

/**
 * Iterates through entities that have a FormulaDisabled field (i.e., entities that can
 * have option set references in their `disabled` formula). This is significantly more
 * efficient than iterating through all entities when you only need to find formula references.
 *
 * @param doc The doc to iterate
 * @param callback The callback to invoke with each entity and its handle
 * @param includeGroups Whether to include GROUP entities (if they support FormulaDisabled)
 */
export function docForEachFormulaDisabledEntity(
  doc: Doc,
  callback: (entity: DocEntity, handle: DocEntityHandle) => void,
  includeGroups = true,
): void {
  docForEachEntity(doc, callback, includeGroups, formulaDisabledEntityTypes.value);
}
